import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-86575262"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "box" }
const _hoisted_2 = { class: "card-box" }
const _hoisted_3 = { class: "icon-title-wrap" }
const _hoisted_4 = { class: "project-title" }
const _hoisted_5 = { class: "tag-list" }
const _hoisted_6 = { class: "desc-line" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "项目经理：", -1))
const _hoisted_8 = { class: "desc-line" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "项目编号：", -1))
const _hoisted_10 = {
  key: 0,
  class: "image_status"
}
const _hoisted_11 = {
  key: 1,
  class: "image_status"
}
const _hoisted_12 = { class: "tab-box" }

import { onMounted, ref } from 'vue'
import { useRouter } from 'vue-router'
import ProjectPreview from './ProjectPreview.vue'
import DailyLog from './DailyLog.vue'
import { getProjectDetail, ProjectData } from '@/apis/projectList'


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const router = useRouter()
const detailActive = ref(0)
const projectId = ref('')
const project_detail = ref({} as ProjectData)

const get_project_detail = async () => {
  let rqs = {
    id: projectId.value
  }
  const res = await getProjectDetail(rqs)
  if (res.code == 200) {
    localStorage.setItem('PROJECT_DETAIL', JSON.stringify(res.data))
    project_detail.value = res.data
  }
}

onMounted(() => {
  projectId.value = router.currentRoute.value.query.id.toString()
  get_project_detail()
})

return (_ctx: any,_cache: any) => {
  const _component_base_nav_bar = _resolveComponent("base-nav-bar")!
  const _component_van_tag = _resolveComponent("van-tag")!
  const _component_van_image = _resolveComponent("van-image")!
  const _component_van_tab = _resolveComponent("van-tab")!
  const _component_van_tabs = _resolveComponent("van-tabs")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_base_nav_bar, {
      title: _ctx.$route.meta.title,
      "left-text": "返回"
    }, null, 8, ["title"]),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, _toDisplayString(project_detail.value.stage_name), 1),
      _createElementVNode("div", _hoisted_4, _toDisplayString(project_detail.value.name), 1),
      _createElementVNode("div", _hoisted_5, [
        _createVNode(_component_van_tag, {
          class: "tag-item",
          color: "#E5EFFF",
          "text-color": "#0C64F5"
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(project_detail.value.type_name), 1)
          ]),
          _: 1
        }),
        _createVNode(_component_van_tag, {
          class: "tag-item",
          color: "#FFF5EA",
          "text-color": "#FF9920"
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(project_detail.value.person_type_desc), 1)
          ]),
          _: 1
        })
      ]),
      _createElementVNode("div", _hoisted_6, [
        _hoisted_7,
        _createElementVNode("span", null, _toDisplayString(project_detail.value.leader?.name || '暂无'), 1)
      ]),
      _createElementVNode("div", _hoisted_8, [
        _hoisted_9,
        _createElementVNode("span", null, _toDisplayString(project_detail.value.number), 1)
      ]),
      (project_detail.value.state == 3)
        ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
            _createVNode(_component_van_image, {
              width: "65",
              height: "65",
              src: require('@/assets/project/finish.png')
            }, null, 8, ["src"])
          ]))
        : _createCommentVNode("", true),
      (project_detail.value.state == 4)
        ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
            _createVNode(_component_van_image, {
              width: "65",
              height: "65",
              src: require('@/assets/project/end.png')
            }, null, 8, ["src"])
          ]))
        : _createCommentVNode("", true)
    ]),
    _createElementVNode("div", _hoisted_12, [
      (project_detail.value)
        ? (_openBlock(), _createBlock(_component_van_tabs, {
            key: 0,
            active: detailActive.value,
            "onUpdate:active": _cache[0] || (_cache[0] = ($event: any) => ((detailActive).value = $event)),
            color: "#0C64F5"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_van_tab, { title: "项目概览" }, {
                default: _withCtx(() => [
                  _createVNode(ProjectPreview, { projectData: project_detail.value }, null, 8, ["projectData"])
                ]),
                _: 1
              }),
              _createVNode(_component_van_tab, { title: "跟进日志" }, {
                default: _withCtx(() => [
                  _createVNode(DailyLog, {
                    project_id: project_detail.value.id
                  }, null, 8, ["project_id"])
                ]),
                _: 1
              })
            ]),
            _: 1
          }, 8, ["active"]))
        : _createCommentVNode("", true)
    ])
  ]))
}
}

})